// extracted by mini-css-extract-plugin
module.exports = {"toaster":"toaster_toaster__v3LY8","toasted":"toaster_toasted__wmmlY"};